var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-nowrap",class:_vm._class},[_c('i',{staticClass:"mr-2",class:_vm.icon}),_c('span',{staticClass:"text-capitalize",domProps:{"textContent":_vm._s(_vm.status)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }